import React from "react";

function Sales() {
  return (
    <div>
      <h2>Sales</h2>
    </div>
  );
}

export default Sales;
